import {
    attachRedReviewMetadata,
    findMatchingBlueMappingGroup,
    resolveRedReviewAction,
} from './red-review-mappings';

const normalizeDeleteMappings = (mappingGroup: any) => {
    const deleteMappings = Array.isArray(mappingGroup?.delete_mappings)
        ? mappingGroup.delete_mappings
        : [];

    return deleteMappings.map((deleteMapping: any) => ({
        ...deleteMapping,
        isDeleted: true,
        reason: mappingGroup.reason || '',
        mapping_label: mappingGroup.mapping_label,
        review_action: mappingGroup.review_action,
        review_analysis: mappingGroup.review_analysis || '',
        review_challenge: mappingGroup.review_analysis || mappingGroup.reason || '',
        review_evidence_strength: mappingGroup.evidence_strength,
        entity_mapping: {},
    }));
};

export const normalizeRedRevisionMappingGroup = (redGroup: any, blueAllMappings: any[] = []) => {
    const blueGroup = findMatchingBlueMappingGroup(redGroup, blueAllMappings);
    if (!blueGroup) {
        return null;
    }

    const reviewAction = resolveRedReviewAction(redGroup);
    const shouldKeepBlue = !reviewAction || reviewAction === 'keep';
    const redMappings = Array.isArray(redGroup?.mappings) ? redGroup.mappings : [];
    const sourceGroup = reviewAction === 'revise' && redMappings.length === 0
        ? { ...redGroup, mappings: blueGroup.mappings || [] }
        : shouldKeepBlue
            ? blueGroup
            : redGroup;
    const normalizedGroup = attachRedReviewMetadata(sourceGroup, redGroup, reviewAction);

    // An approved or unfinished review must not be affected by any red revision
    // payload, including mappings or delete_mappings that may still be present.
    if (shouldKeepBlue) {
        return normalizedGroup;
    }

    if (reviewAction === 'add_evidence') {
        const normalizedBlueGroup = attachRedReviewMetadata(
            blueGroup,
            { ...redGroup, mappings: [] },
            reviewAction
        );
        const blueMappings = Array.isArray(normalizedBlueGroup.mappings)
            ? normalizedBlueGroup.mappings
            : [];
        const redMappings = Array.isArray(normalizedGroup.mappings)
            ? normalizedGroup.mappings
            : [];

        return {
            ...normalizedGroup,
            mappings: [...blueMappings, ...redMappings],
        };
    }

    const deletedMappings = normalizeDeleteMappings(normalizedGroup);
    const hasRedMappings = redMappings.length > 0;

    if (deletedMappings.length === 0) {
        return normalizedGroup;
    }

    const revisionMappings = hasRedMappings
        ? (normalizedGroup.mappings || [])
        : [{
            isEmpty: true,
            reason: normalizedGroup.reason || '',
            mapping_label: normalizedGroup.mapping_label,
            review_action: normalizedGroup.review_action,
            review_analysis: normalizedGroup.review_analysis || '',
            review_challenge: normalizedGroup.review_challenge || '',
            review_evidence_strength: normalizedGroup.review_evidence_strength,
            stance_strength: normalizedGroup.stance_strength,
            entity_mapping: {},
        }];

    return {
        ...normalizedGroup,
        mappings: [
            ...deletedMappings,
            ...revisionMappings
        ],
    };
};
